module.exports = __webpack_public_path__ + "img/5-3.807128b3.png";